import React from 'react';
import { useTranslation } from 'react-i18next';
import { museoSection2 } from '../utils/museoContent';
import { museoSection2En } from '../utils/museoContentEn';
import { getRelatedSectionsForMuseo } from '../utils/relatedSections';
import RelatedSections from './RelatedSections';

const Museo2 = () => {
  const { t, i18n } = useTranslation();
  const content = i18n.language === 'en' ? museoSection2En : museoSection2;

  return (
    <div className='TesisPage TesisPage--museo'>
      <aside className='TesisPage-rail'>
        <RelatedSections items={getRelatedSectionsForMuseo('/Museo2')} />
      </aside>
      <h1 className='TesisPageTitle'>{t('museo2.title')}</h1>
      <h2 className='TesisPageSubtitle'>{t('museo2.subtitle')}</h2>
      <article className='TesisPageContent'>
        {content.map((p, i) => <p key={i}>{p}</p>)}
      </article>
    </div>
  );
};

export default Museo2;
